module.exports = __webpack_public_path__ + "img/mail.3a0d33c3.svg";